import { useMutation } from "@tanstack/react-query";
import { useTablePreferencesManager } from "@/tanstackQuery/queries";
import {
  updateTablePreferences,
  UpdateTablePreferencesPayload,
} from "@/api/tablePreferences";

export const useUpdateTablePreferences = (tableKey: string) => {
  const tablePrefsManager = useTablePreferencesManager(tableKey);

  return useMutation({
    mutationFn: (payload: UpdateTablePreferencesPayload) => {
      return updateTablePreferences(tableKey, payload);
    },

    onMutate: (payload) => {
      const previous = tablePrefsManager.get();
      tablePrefsManager.patch(payload);
      return { previous };
    },

    onSuccess: (data) => {
      tablePrefsManager.replace(data);
    },

    onError: (_error, _payload, context) => {
      if (context?.previous) {
        tablePrefsManager.replace(context.previous);
      }
    },
  });
};
